import React, { useState, FormEvent, useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import { encode } from 'base-64';
import { User, Key, Info } from "phosphor-react";
import { Input, Form, Label, Button, Checkbox } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import packageJson from '../../../package.json';
import { BrowserView, MobileView } from 'react-device-detect';

import { LoginService } from '../../services/methods/LoginService';

import { useAuth } from '../../hooks/auth';
import { useUser } from '../../hooks/user';

import ForgetPasswordModal from '../../components/ForgetPasswordModal';

import {
  Container,
  MobileViewContainer,
  MobileViewDescription,
  MobileContainerButtons,
  LoginBox,
  LogoContainer,
  Logotipo,
  Footer,
  InputLabel,
  CheckboxContainer,
  LinkContainer,
  LoginBoxMobile,
  MobileViewTitle
} from './styles';

import logoEthosx from '../../assets/images/logo.png';
import { styleSheet } from '../../assets/styles/global';

const Login: React.FC = () => {
  const loginService: LoginService = new LoginService();

  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [modalForgetPassword, setModalForgetPassword] = useState(false);

  const { userIsLogged } = useAuth()
  const { storeUserInfo } = useUser()

  const history = useHistory()

  async function handleSubmit(event: FormEvent) {
    event.preventDefault()

    if(!user || !password) {
      return toast.error('Informe o e-mail e senha para fazer o login.');
    }
    
    const userBase64 = encode(user);
    const passwordBase64 = encode(password);

    setIsLoading(true);
    try {
      const { data, status } = await loginService.auth(userBase64, passwordBase64);

      const { infoMsg, token, dados } = data
      if(status === 200) {
        if (rememberMe) {
          await localStorage.setItem('ethosxAnalista:token', token)
        }
        await sessionStorage.setItem('token', token)

        await storeUserInfo({
          ...dados,
          color: dados.color === '' ? '#ccc' : dados.color
        })

        history.push('/schedule')
      } else {
        return toast.error(data.errorMessage)
      }
    } catch (error: any) {
      if (error.response) {
        toast.error(error.response.data.errorMessage)
      }
      console.log(error)
    } finally {
      setIsLoading(false);
    }
  }

  function handleForgotPasswordClick() {
    setModalForgetPassword(true);
  }

  useEffect(() => {

    if (userIsLogged()) {
      history.push('/schedule')
    }
    // eslint-disable-next-line
  }, [])

  return (
    <Container>
      <BrowserView>
        <LoginBox>
          <LogoContainer>
            <Logotipo src={logoEthosx} alt="Logo EthosX"/>
          </LogoContainer>
          <Form>
            <Form.Field>
              <InputLabel>Usuário</InputLabel>
              <Input size='big'>
                <Label basic style={{ backgroundColor: styleSheet.colorMain, borderColor: styleSheet.colorMain }}>
                  <User size={22} color='#fff' />
                </Label>
                <Input
                  placeholder='Digite seu usuário'
                  onChange={(value) => { setUser(value.currentTarget.value) }}
                />
              </Input>
            </Form.Field>
            <Form.Field >
              <InputLabel>Senha</InputLabel>
              <Input size='big'>
                <Label basic style={{ backgroundColor: styleSheet.colorMain, borderColor: styleSheet.colorMain }}>
                  <Key size={22} color='#fff' />
                </Label>
                <Input
                  type='password'
                  placeholder='Digite sua senha'
                  onChange={(value) => { setPassword(value.currentTarget.value) }}
                />
              </Input>
            </Form.Field>
            <Form.Field>
              <CheckboxContainer>
                <Checkbox
                  toggle
                  label='Logar automáticamente'
                  checked={rememberMe}
                  onChange={(ev) => {
                    const ele = ev.target as HTMLLabelElement;
                    setRememberMe(!ele.parentElement!.classList.contains('checked'))
                  }}
                />
              </CheckboxContainer>
            </Form.Field>
            <Button
              positive
              fluid
              size='huge'
              type='submit'
              icon="checkmark"
              content="Entrar"
              labelPosition='right'
              onClick={handleSubmit}
              disabled={isLoading} //|| (username === '' || password === '')}
              loading={isLoading}
              style={{ width: '80%', marginLeft: '10%', marginTop: '4rem', marginBottom: '3rem' }}
            />
          </Form>

          <LinkContainer>
            <Button
              style={{
                background: 'transparent',
                fontSize: '1.3rem',
                fontFamily: styleSheet.mainFont,
                fontWeight: '600',
                color: '#4183c4'
              }}
              onClick={() => handleForgotPasswordClick()}//history.push('/forgotPassword')}
            >
              Esqueci minha senha
            </Button>

          </LinkContainer>

          <Footer>
            <span>{packageJson.version}</span>
          </Footer>
        </LoginBox>
      </BrowserView>
      <MobileView>
        <LoginBoxMobile>
          <MobileViewContainer>
            <Info size={60} weight="thin" color={styleSheet.colorMain} />
            <MobileViewTitle>Atenção!</MobileViewTitle>
            <MobileViewDescription>
              Para uma melhor experiência, recomendamos o download do aplicativo para Android ou IOS do Aion no link abaixo:
            </MobileViewDescription>

            <MobileContainerButtons>
                <Button
                  as="a"
                  href="https://aion.ethosx.com.br/app/aion.apk"
                  icon="android"
                  style={{ backgroundColor: '#A4c639', color: styleSheet.shape }}
                  size="massive"
                />


                <Button
                  as="a"
                  href={`itms-services://?action=download-manifest&amp;url=https://aion.ethosx.com.br/app/app.plist`}
                  icon="apple"
                  style={{ backgroundColor: '#a9a9a9', color: styleSheet.shape }}
                  size="massive"
                />
            </MobileContainerButtons>
          </MobileViewContainer>
        </LoginBoxMobile>
      </MobileView>

      <ForgetPasswordModal
        forgetPasswordModalOpen={modalForgetPassword}
        setForgetPasswordModalOpen={setModalForgetPassword}
      />
    </Container>
  );
}

export default Login;